import apiClient from './client';

export const newsApi = {
  /**
   * Get news articles from database
   */
  getNews: async (params = {}) => {
    const response = await apiClient.get('/api/news', { params });
    return response.data;
  },

  /**
   * Get news statistics
   */
  getStats: async () => {
    const response = await apiClient.get('/api/news/stats');
    return response.data;
  },

  /**
   * Sync news from Alpaca to database
   */
  syncNews: async (params = {}) => {
    const response = await apiClient.post('/api/news/sync', params);
    return response.data;
  },

  /**
   * Fetch news directly from Alpaca and save to database
   */
  fetchNews: async (params = {}) => {
    // Ensure sort is set to 'desc' for newest first
    const fetchParams = {
      sort: 'desc',
      ...params,
    };
    const response = await apiClient.get('/api/news/fetch', { params: fetchParams });
    return response.data;
  },

  /**
   * Analyze sentiment for a specific article
   */
  analyzeSentiment: async (articleId) => {
    const response = await apiClient.post(`/api/news/${articleId}/analyze`);
    return response.data;
  },

  /**
   * Batch analyze sentiment for multiple articles
   */
  batchAnalyzeSentiment: async (articleIds, batchSize = 5) => {
    const response = await apiClient.post('/api/news/analyze/batch', {
      articleIds,
      batchSize,
    });
    return response.data;
  },

  /**
   * Analyze sentiment for all unanalyzed articles
   */
  analyzeUnanalyzed: async (limit = 50) => {
    const response = await apiClient.post('/api/news/analyze/unanalyzed', {
      limit,
    });
    return response.data;
  },

  /**
   * Generate AI summary for a specific article
   */
  summarizeArticle: async (articleId, forceRegenerate = false) => {
    const response = await apiClient.post(`/api/news/${articleId}/summarize`, {}, {
      params: { forceRegenerate },
    });
    return response.data;
  },

  /**
   * Batch generate summaries for multiple articles
   */
  batchSummarize: async (articleIds, batchSize = 3) => {
    const response = await apiClient.post('/api/news/summarize/batch', {
      articleIds,
      batchSize,
    });
    return response.data;
  },
};
